/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — clears per-visit gift-purchase state (recipient/
 *              message/style) when navigating away from vouchers
 *   extends:   Route
 *   template:  none
 *   model:     - (none defined)
 *   key:       resetController
 *   uses:      -
 *   siblings:  controllers/vouchers.js, templates/vouchers.hbs
 *   tests:     route-hooks-test.js
 *   gotchas:   resetController only clears state when `isExiting` is true, so
 *              a same-route query-param refresh does not wipe an in-progress
 *              gift selection.
 */
import Route from '@ember/routing/route';

export default class VouchersRoute extends Route {
  // Clear per-visit gift state so a repeat voucher purchase does not inherit the
  // previous recipient/message/style (maint 5.6 leak fix).
  resetController(controller, isExiting) {
    if (isExiting) {
      controller.set('giftSelected', null);
      controller.set('gift_message', null);
      controller.set('gift_to', null);
      controller.set('gift_style', null);
    }
  }
}
